var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiltreModuleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 30,
    height: 30,
    fill: "white",
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000 9.000) scale(1.0625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5455 15.0586H1.45455C0.64 15.0586 0 14.4146 0 13.5949V4.08088C0 3.26121 0.64 2.61719 1.45455 2.61719H14.5455C15.36 2.61719 16 3.26121 16 4.08088V13.5949C16 14.3853 15.36 15.0586 14.5455 15.0586ZM1.45455 3.34903C1.04727 3.34903 0.727273 3.67105 0.727273 4.08088V13.5949C0.727273 14.0047 1.04727 14.3267 1.45455 14.3267H14.5455C14.9527 14.3267 15.2727 14.0047 15.2727 13.5949V4.08088C15.2727 3.67105 14.9527 3.34903 14.5455 3.34903H1.45455Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9041 2.96675H10.1768V1.88362C10.1768 1.47378 9.85685 1.15177 9.44957 1.15177H6.54048C6.13321 1.15177 5.81321 1.47378 5.81321 1.88362V2.99602H5.08594V1.88362C5.08594 1.06395 5.72594 0.419922 6.54048 0.419922H9.44957C10.2641 0.419922 10.9041 1.06395 10.9041 1.88362V2.96675Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.378906 8.08984H15.6516V8.82169H0.378906V8.08984Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98438 8.46973H4.71165V10.314H3.98438V8.46973Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2617 8.46973H11.989V10.314H11.2617V8.46973Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltreModuleIcon);
export default __webpack_public_path__ + "static/media/filtreModuleIcon.afb5332e6df7fec94d8e34891254a8b6.svg";
export { ForwardRef as ReactComponent };